export default __webpack_public_path__ + "static/media/358.8de1f846.gif";